<template>
  <div>
    <img :src=cover width="100px" height="100px" style="border-radius: 50%">
    <p>{{ index }}&nbsp;{{ title }}</p>
  </div>
</template>

<script>
export default {
  name: "SongCircle",
  data() {
    return {}
  },
  props: ['index', 'title', 'cover']
}
</script>

<style scoped>
p {
  color: white;
}

img {
  padding: 30px 0 10px 0;
}
</style>